import React from 'react';
import styled from '@emotion/styled/macro';
import TableHeaderCell from './table-header-cell';
import { generateKey } from '../../../utils/utils';

const TableHeader = ({ data, className }) => {
  if (Array.isArray(data)) {
    return (
      <thead className={className} data-testid="table-header">
        <tr>
          {data.map((headerCell, index) => {
            return (
              <TableHeaderCell
                key={generateKey(headerCell.label, index)}
                width={headerCell.width ? headerCell.width : null}
              >
                {headerCell.label}
              </TableHeaderCell>
            );
          })}
        </tr>
      </thead>
    );
  } else {
    console.warn(`TableHeader received non valid argument - data:`, data);
  }
};

// === TableHeader CSS ===
const StyledTableHeader = styled(TableHeader)`
  height: 6rem;
`;

export default StyledTableHeader;
